/* unplugin-vue-components disabled */import script from "./StudyMaterialDetailContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudyMaterialDetailContent.vue?vue&type=script&setup=true&lang=ts"

import "./StudyMaterialDetailContent.vue?vue&type=style&index=0&id=09dba120&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09dba120"]])

export default __exports__